import React from "react";
import { TableView } from "../TableView";
import { createTableColumns } from "./tableConfig";
import { Proposal } from "@trnsact/trnsact-shared-types";
import { ProposalTableActions } from "../../../types";

interface Props extends ProposalTableActions<Proposal> {
  loading?: boolean;
  tableData: Proposal[];
}

export const AftermarketPartnerProposalsTable = ({ tableData, loading, ...actions }: Props) => {
  const columns = createTableColumns({ tableData, ...actions });

  return <TableView<Proposal> loading={loading} minHeight="33.5rem" columns={columns} tableData={tableData} />;
};
